import { gsap } from 'gsap'
import { CSSRulePlugin } from 'gsap/CSSRulePlugin'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import Plyr from 'plyr'

gsap.registerPlugin(CSSRulePlugin, ScrollTrigger)

const lib = require('../library')
export default class VideoBg {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.video = this.el.querySelector('[data-featuredvideo]')
    this.videoEmbed = this.el.querySelector('[data-video]')
    this.player = new Plyr(this.videoEmbed, {})
    this.start = this.el.querySelector('[data-startstate]')
    this.height = ''
    this.startHeight = ''
    this.button = this.el.querySelector('[data-play]')
    this.window = window
  }

  init() {
    const player = new Plyr(this.el, {})
    this.handleSetHeights()
    this.button.addEventListener('click', this.handlePlay)
    this.window.addEventListener('resize', this.handleSetHeights)
  }

  handlePlay = () => {
    // fade out the textural video
    // fade in the actual video
    // auto play the video using our customer player
    const currentHeight = lib.getHeight(this.el)
    const tl = gsap.timeline({ duration: 0.8, ease: 'power2.out' })
    gsap.set(this.start, { position: 'absolute' })
    tl.to(this.start, {
      autoAlpha: 0,
      display: 'none',
    })
    tl.fromTo(
      this.el,
      {
        height: currentHeight,
      },
      {
        height: this.height,
      },
      '<',
    )
    tl.to(
      this.window,
      {
        duration: 0.3,
        scrollTo: { y: this.el, offsetY: this.handlePosition() },
      },
      '<',
    )
    tl.fromTo(
      this.video,
      {
        opacity: 0,
      },
      {
        autoAlpha: 1,
        display: 'block',
      },
    )
    this.handlePosition()
    this.player.play()
  }

  handleResize() {
    this.handleSetHeights()
  }

  handleSetHeights = () => {
    this.startHeight = lib.getHeight(this.start)
    const videoHeight = lib.getHeight(this.video)
    const maxHeight = this.window.innerHeight
    this.height = maxHeight < videoHeight ? maxHeight : videoHeight
  }

  handlePosition = () => {
    // calculate the scroll position
    let shift = 0
    if (this.height < this.window.innerHeight) {
      shift = (this.window.innerHeight - this.height) / 2
    }
    return shift
  }
}
